export enum ContentHeaderTab {
  partner = "partner",
  additionalData = "additionalData",
  sales = "sales"
}
